import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DatafoxDevice } from "../models/datafox-device.model";
import { AlertService } from "./alert.service";
import { AuthService } from "./auth.service";
import { EndpointFactoryService } from "./endpoint-factory.service";

@Injectable()
export class TerminalsEndpointService extends EndpointFactoryService {

  protected URL: string = "/api/Device/";

  constructor(http: HttpClient, alertService: AlertService, authService: AuthService) {
    super(http, alertService, authService);
  }

  public getAllDataFoxDevices(showError: boolean = true): Observable<DatafoxDevice[]> {
    return this.getAuthorizedWithErrorHandling(this.URL, () => this.getAllDataFoxDevices(showError), null, showError);
  }

  public get(serialnumber: string, type: string, showError: boolean = true): Observable<DatafoxDevice> {
    return this.getAuthorizedWithErrorHandling(this.URL + type + '/' + serialnumber, () => this.get(serialnumber, type, showError), null, showError);
  }

  public update(data: DatafoxDevice, showError: boolean = true): Observable<DatafoxDevice> {
    return this.putAuthorizedWithErrorHandling(this.URL + data.deviceType + '/' + data.serialNumber, data, () => this.update(data, showError), null, showError);
  }

  public create(data: DatafoxDevice, showError: boolean = true): Observable<DatafoxDevice> {
    return this.postAuthorizedWithErrorHandling(this.URL, data, () => this.create(data, showError), null, showError);
  }

  public delete(serialnumber: string, type: string, showError: boolean = true): Observable<any> {
    return this.deleteAuthorizedWithErrorHandling(this.URL + type + '/' + serialnumber, () => this.delete(serialnumber, type, showError), null, showError);
  }

  public getDeviceTypes(showError: boolean = true): Observable<string[]> {
    return this.getAuthorizedWithErrorHandling(this.URL + 'Types', () => this.getDeviceTypes(showError), null, showError);
  }

  public setServiceMode(data: DatafoxDevice, showError: boolean = true): Observable<DatafoxDevice> {
    return this.postAuthorizedWithErrorHandling(this.URL + data.deviceType + '/' + data.serialNumber + '/ServiceMode', null, () => this.setServiceMode(data, showError), null, showError);
  }

}
